import { useT, LANGUAGES } from "@/i18n/I18nContext";
import { Globe } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang } = useT();
  return (
    <div className="inline-flex items-center gap-1 border border-zinc-200 bg-white" data-testid="lang-switcher">
      <div className="px-2 py-1.5 border-r border-zinc-200 text-zinc-500">
        <Globe className="w-3.5 h-3.5" />
      </div>
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={`px-2.5 py-1.5 text-[11px] font-mono uppercase tracking-wider transition-colors ${
            lang === l.code ? "bg-[#F5A623] text-white" : "text-zinc-600 hover:bg-zinc-50"
          }`}
          title={l.name}
          data-testid={`lang-${l.code}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
